let TP_SERVER_DOMAIN,
    AGGR_DOMAIN,
    EXPLORER_TRANSIT_DOMAIN,
    TP_FORWARD_DOMAIN,
    TP_SOCKET_DOMAIN,
    TP_PROFIT_DOMAIN,
    COOKIE_DOMAIN,
    TRANSIT_DOMAIN;

if (process.env.VUE_APP_ENV === 'production') {
    TP_SERVER_DOMAIN = 'https://preserver.mytokenpocket.vip';
    AGGR_DOMAIN = 'https://aggserver.mytokenpocket.vip';
    EXPLORER_TRANSIT_DOMAIN = 'https://explorer.transit.finance';
    TP_FORWARD_DOMAIN = 'https://forward.mytokenpocket.vip';
    TP_SOCKET_DOMAIN = 'wss://pushserver.mytokenpocket.vip/ws';
    TP_PROFIT_DOMAIN = 'https://profit.mytokenpocket.vip';
    COOKIE_DOMAIN = 'transit.finance';
    TRANSIT_DOMAIN = 'https://transit.finance';
} else if (process.env.VUE_APP_ENV === 'beta') {
    // TP_SERVER_DOMAIN = 'https://preserver.mytokenpocket.vip';
    TP_SERVER_DOMAIN = 'https://betaserver.mytokenpocket.vip';
    AGGR_DOMAIN = 'https://aggserver.mytokenpocket.vip';
    EXPLORER_TRANSIT_DOMAIN = 'https://explorer.transit.finance';
    TP_FORWARD_DOMAIN = 'https://forward.mytokenpocket.vip';
    TP_SOCKET_DOMAIN = 'wss://pushserver.mytokenpocket.vip/ws';
    TP_PROFIT_DOMAIN = 'https://profit.mytokenpocket.vip';
    COOKIE_DOMAIN = 'transit.finance';
    TRANSIT_DOMAIN = 'https://transit.finance';
} else if (process.env.VUE_APP_ENV === 'dev') {
    TP_SERVER_DOMAIN = 'https://testserver.mytokenpocket.vip';
    AGGR_DOMAIN = 'https://agtest.mytokenpocket.vip';
    EXPLORER_TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro/swap-explorer';
    TP_FORWARD_DOMAIN = 'https://forwardtest.mytokenpocket.vip';
    TP_SOCKET_DOMAIN = 'wss://testpushserver.mytokenpocket.vip/ws';
    TP_PROFIT_DOMAIN = 'https://test-profit.mytokenpocket.vip';
    COOKIE_DOMAIN = 'tokenpocket.pro';
    TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro/transit-finance';
}

export {
    TP_SERVER_DOMAIN,
    AGGR_DOMAIN,
    EXPLORER_TRANSIT_DOMAIN,
    TP_FORWARD_DOMAIN,
    TP_SOCKET_DOMAIN,
    TP_PROFIT_DOMAIN,
    COOKIE_DOMAIN,
    TRANSIT_DOMAIN,
};
